import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/persetujuan-anestesi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/persetujuan-anestesi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/persetujuan-anestesi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/persetujuan-anestesi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signSaksiRs(id: number, data) {
  const response = await http.putData(`/persetujuan-anestesi/${id}/sign-saksi-rs`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDrAnestesi(id: number, data) {
  const response = await http.putData(`/persetujuan-anestesi/${id}/sign-dr-anestesi`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markPenyetuju(id: number, data) {
  const response = await http.putData(`/persetujuan-anestesi/${id}/mark-penyetuju`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markSaksiKeluarga(id: number, data) {
  const response = await http.putData(`/persetujuan-anestesi/${id}/mark-saksi-keluarga`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/persetujuan-anestesi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/persetujuan-anestesi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signSaksiRs,
  signDrAnestesi,
  markPenyetuju,
  markSaksiKeluarga,
  destroy,
  print
};
